export default __webpack_public_path__ + "static/media/03.19.25 Minutes Reg Mtg.6663ae43.pdf";